module.exports = __webpack_public_path__ + "img/satellite.0e311311.svg";